import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { sessionStartTimeAtom } from '../../atoms/session-atoms';

/**
 * Resets sessionStartTimeAtom to Date.now() on mount (i.e. on each new task).
 */
export function useSessionStartTime() {
  const setSessionStartTime = useSetAtom(sessionStartTimeAtom);
  useEffect(() => {
    setSessionStartTime(Date.now());
  }, [setSessionStartTime]);
}